export default __webpack_public_path__ + "static/media/release-notes.79931367.md";